import React from 'react'
import { colors, font, mq } from 'plume-ui'
import { css } from '@emotion/react'
import { A } from '../atoms/A'
import { IcomoonIcon } from '../atoms/IcomoonIcon'
import { trialRequestUrl } from '@/lib/url'

export const LimitedToEnterpriseContents: React.FC<{}> = () => {
  return (
    <div
      css={css`
        font-weight: ${font.weight.normal};
        line-height: 175%;
        letter-spacing: 0.02em;
        color: ${colors.text};
        ${mq.untilMedium} {
          font-size: 14px;
        }
        ${mq.large} {
          font-size: 14px;
        }
      `}
    >
      <IcomoonIcon
        name="lock-fill"
        css={css`
          color: ${colors.textStrong};
          font-size: 14px;
          margin-right: 4px;
        `}
      />
      有料契約限定のコンテンツです。
      <br />
      <A href={trialRequestUrl} target="blank" decoration="none">
        無料トライアルに申し込む
      </A>
      とご覧になれます。
    </div>
  )
}
